import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Vault, ChevronRight, KeyRound } from "lucide-react";
import { api } from "@/lib/api";

export function VaultFeedBanner() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/vault").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return null;
  return (
    <Link to="/spiele/tresor" data-testid="feed-vault-banner" className="group relative flex items-center gap-4 p-4 rounded-3xl bg-slate-950 text-white ring-1 ring-amber-400/40 overflow-hidden active:scale-[0.98] transition-transform">
      <span className="absolute -top-16 -right-10 w-48 h-48 rounded-full bg-amber-500/25 blur-3xl pointer-events-none" />
      <span className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-300 to-amber-600 text-slate-900 grid place-items-center shrink-0 shadow-[0_0_20px_rgba(251,191,36,0.5)]"><Vault className="w-7 h-7" /></span>
      <span className="relative flex-1 min-w-0">
        <span className="block text-[10px] font-extrabold uppercase tracking-[0.2em] text-amber-300">Goldener Tresor #{s.round.no}</span>
        <span className="block font-display text-2xl font-black text-amber-300 vault-pot tabular-nums" data-testid="feed-vault-pot">{s.round.pot.toLocaleString("de-DE")} Punkte</span>
        <span className="block text-xs text-white/70 flex items-center gap-1"><KeyRound className="w-3.5 h-3.5" /> {s.round.locked ? "Der neue Tresor öffnet um 9 Uhr" : `${s.keys.left} Schlüssel übrig · Knack den Code zuerst!`}</span>
      </span>
      <ChevronRight className="relative w-6 h-6 shrink-0 text-amber-300 group-hover:translate-x-1 transition-transform" />
    </Link>
  );
}
